import client from '@/lib/axios-client'
import type {
	PendenciesMeOutput,
	PendenciesMeParams,
	PendencyRawItem,
} from '@/types/pendency'

const PENDENCIES_URL = '/pendencies/me'
const PENDENCIES_EXPORT_URL = '/pendencies/me/export'

export async function getMyPendencies(
	params?: PendenciesMeParams,
): Promise<PendenciesMeOutput> {
	const response = await client.get(PENDENCIES_URL, { params })
	const payload = response.data?.data

	if (Array.isArray(payload)) {
		return { items: payload as PendencyRawItem[] }
	}

	if (payload && Array.isArray(payload.items)) {
		return {
			items: payload.items as PendencyRawItem[],
			facets: payload.facets,
			appliedFilters: payload.appliedFilters,
		}
	}

	return { items: [] }
}

export async function exportMyPendencies(
	params: PendenciesMeParams,
	format: 'xlsx' | 'pdf',
): Promise<Blob> {
	const response = await client.get(PENDENCIES_EXPORT_URL, {
		params: { ...params, format },
		responseType: 'blob',
	})
	return response.data
}
